import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll immédiatement vers le haut à chaque changement de route
    window.scrollTo(0, 0);
    
    // Aussi pour les éléments avec du scroll personnalisé
    const scrollElements = document.querySelectorAll('[data-scroll-container]');
    scrollElements.forEach(element => {
      element.scrollTop = 0;
    });
  }, [pathname]);

  return null;
};